/**
 * Ensure PrismJS is available globally before @lexical/code loads.
 * Bun's bundler wraps CJS modules in scopes, preventing PrismJS's
 * `_self.Prism = _` assignment from reaching `window`.
 */
import Prism from "prismjs";

globalThis.Prism = Prism;
